import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType } from '../types/translation-types';

export class DownloadPreviewUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  /**
   * Download a preview file by fetching it with auth headers and triggering browser download
   */
  async execute(applicationType: ApplicationType, fileName: string, fileKey?: string): Promise<void> {
    const url = this.repository.getPreviewDownloadUrl(applicationType, fileKey);
    const headers = await this.repository.getDownloadHeaders();

    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      throw new Error(`Download failed: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(downloadUrl);
  }
}
